import { DeviceService } from '@/app/platform/platform-data/services/types';
import { Injectable } from '@angular/core';
import { AsyncResult } from '@common/result/asyncResult';
import { PlatformDeviceService } from '@data/_generated-api/platform-api/services/platform-device.service';
import { err, ok } from '@common/result/Result';
import Morphism from 'morphism';
import { DeviceEntity } from '@/app/platform/platform-data/models/device.entity';
import { PlatformDataSourceQuery } from '@data/_generated-api/platform-api/models/platform-data-source-query';

@Injectable({
  providedIn: 'root'
})
export class DeviceFacade implements DeviceService {
  constructor(private readonly upamDeviceService: PlatformDeviceService) {}

  async create(model: DeviceEntity): AsyncResult<DeviceEntity> {
    const result = await this.upamDeviceService
      .postDevices({ body: model.creationModel })
      .toPromise();

    if (!result.isValid) {
      return err();
    }

    const device = Morphism.map(DeviceEntity, result.value);
    return ok(device);
  }

  async delete({ deleteKey }: DeviceEntity): AsyncResult<DeviceEntity> {
    const result = await this.upamDeviceService
      .deleteDevices({ body: { id: deleteKey } })
      .toPromise();

    if (!result.isValid) {
      return err();
    }

    const d = Morphism.map(DeviceEntity, result.value);
    return ok(d);
  }

  async getAll(...args: any[]): AsyncResult<DeviceEntity[]> {
    const result = await this.upamDeviceService
      .postDevicesQueryDatasource({ body: {} })
      .toPromise();
    if (!result.isValid) {
      return err();
    }

    const devices = Morphism.map(DeviceEntity, result.value.items);
    return ok(devices);
  }

  async getAllWithQuery(query: PlatformDataSourceQuery): AsyncResult<[DeviceEntity[], number]> {
    const result = await this.upamDeviceService
      .postDevicesQueryDatasource({
        body: {
          dataSourceQuery: query
        }
      })
      .toPromise();
    if (!result.isValid) {
      return err();
    }

    const devices = Morphism.map(DeviceEntity, result.value.items);
    const res: [DeviceEntity[], number] = [devices, result.value.totalRecordCount];
    return ok(res);
  }

  async update(model: DeviceEntity): AsyncResult<DeviceEntity> {
    const result = await this.upamDeviceService
      .putDevices({
        body: model.editingModel
      })
      .toPromise();

    if (!result.isValid) {
      return err();
    }

    const d = Morphism.map(DeviceEntity, result.value);
    return ok(d);
  }
}
